import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import ProgressBar from '../../shared/components/charts/ProgressBar';
import Header from '../../PrincipalPaydown/components/Hero/Header';

import Formatters from  '../../shared/utils/Formatters';
import Calculation from  '../../shared/utils/Calculation';

const propTypes = {
  amountToPayDownWithInterest:      PropTypes.number.isRequired,
  outstandingPrincipalWithInterest: PropTypes.number.isRequired,
};

const UnlockLockBar = ({ unlockDate, amountToPayDownWithInterest, outstandingPrincipalWithInterest }) => {

  const outstandingPrincipalWithInterestInPeso = () => {
    return Formatters.currency({ amount: outstandingPrincipalWithInterest });
  }

  const renderLockBar = () => {
    return (
      <Fragment>
        <p className="byline --small">
          You owe a total of <strong className='-darkBlue'>{outstandingPrincipalWithInterestInPeso()}</strong>
        </p>
        <ProgressBar
          fullValue={outstandingPrincipalWithInterest}
          currentValue={outstandingPrincipalWithInterest - amountToPayDownWithInterest}
          partialValue={amountToPayDownWithInterest}
        />
      </Fragment>
    );
  }

  const payDownPercentage = () => Calculation.percentage({ part: amountToPayDownWithInterest, full: outstandingPrincipalWithInterest });

  const amountToPayDownWithInterestInPeso = () => {
    return Formatters.currency({ amount: amountToPayDownWithInterest });
  }

  const renderPercentOfTotalOwned = () => <p className="byline" data-testid="percentage-owed">({payDownPercentage()}% of total owed)</p>;

  const renderEmphasizedAmount = () => <strong className="subhead -info">{amountToPayDownWithInterestInPeso()}</strong>;

  const renderUnlockDate = () => Formatters.date(unlockDate);

  const renderCopy = () => {
    return (
      <p className="byline _marginBottom--small">
        If you want to apply for another loan before {renderUnlockDate()}*,
        <br className='_displayNone-mobileOnly' />
        &nbsp;you need to repay <br className='_displayNone-tabletUp' />{renderEmphasizedAmount()}
      </p>
    );
  }

  return (
    <div className="ds-card" data-testid="unlock-credit-component">
      <div className="cardSection _alignCenter">
        <Header text='Unlock your credit' />
        {renderCopy()}
        {renderPercentOfTotalOwned()}
        {renderLockBar()}
      </div>
    </div>
  );
}

UnlockLockBar.propTypes = propTypes;
export default UnlockLockBar;



// WEBPACK FOOTER //
// ./src/features/applyNow/components/UnlockLockBar.js